import { isIpadApp } from '@src/slide/infrastructure/module/dependent/config/tob/enterprise-config';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import BaseShortcutKeyManager from '../base/manager';
import { ShortcutActionName } from '../constants';
import { IMobileActionsInjectable, IMobileShortcutKeyManager, IMobileShortcutKeyServices, IMobileShortcutKeyManagerInjectable } from '../interface';
import MobileShortcutActions from './actions';

export default class MobileShortcutKeyManager extends BaseShortcutKeyManager implements IMobileShortcutKeyManager {
    protected declare services: IMobileShortcutKeyServices;
    // manager 自身的异化逻辑
    protected readonly injectable?: IMobileShortcutKeyManagerInjectable;
    // action 的异化逻辑
    protected readonly actionsInjectable?: IMobileActionsInjectable;

    public constructor(injectable?: IMobileShortcutKeyManagerInjectable, actionsInjectable?: IMobileActionsInjectable) {
        super(injectable, actionsInjectable);
        this.injectable = injectable;
        this.actionsInjectable = actionsInjectable;
    }
    protected getCtrlKey() {
        return browser.isIPad ? 'command' : 'ctrl';
    }

    protected getShortcutConfig() {
        const ctrl = this.getCtrlKey();
        const shortcutConfig = super.getShortcutConfig();
        shortcutConfig[`${ctrl}+i`] = this.handleAction.bind(this, ShortcutActionName.ITALIC);
        shortcutConfig[`${ctrl}+b`] = this.handleAction.bind(this, ShortcutActionName.BOLD);
        shortcutConfig[`${ctrl}+u`] = this.handleAction.bind(this, ShortcutActionName.UNDERLINE);
        shortcutConfig[`${ctrl}+d`] = this.handleAction.bind(this, ShortcutActionName.DELETE_LINE);

        if (isIpadApp()) {
            shortcutConfig[`${ctrl}+c`] = this.handleAction.bind(this, ShortcutActionName.COPY);
            shortcutConfig[`${ctrl}+v`] = this.handleAction.bind(this, ShortcutActionName.PASTE);
            shortcutConfig[`${ctrl}+x`] = this.handleAction.bind(this, ShortcutActionName.CUT);
        }

        return shortcutConfig;
    }

    protected createShortcutActions() {
        return new MobileShortcutActions(this.services, this.actionsInjectable);
    }
}
